import script from "./HighlightSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightSection.vue?vue&type=script&setup=true&lang=js"

import "./HighlightSection.vue?vue&type=style&index=0&id=f3dde5fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3dde5fe"]])

export default __exports__